import React from 'react';
import { Button, withStyles, CircularProgress } from '@material-ui/core';

const styles = (theme) => ({
  container: {
    flex: 1,
    zIndex: 2,
    display: 'flex',
    position: 'absolute',
    width: '100%',
    height: `calc(100% - 48px)`,
    backgroundColor: theme.ModalBGColor,
    justifyContent: 'center',
    alignItems: 'center'
  },
  content: {
    display: 'flex',
    flexDirection: 'column'
  },
  text: {
    color: theme.iconColor,
    fontSize: theme.textFontSize,
    fontWeight: 600,
    textTransform: 'uppercase',
    lineHeight: '16px',
    paddingBottom: 20,
    paddingTop: 20
  },
  progressIcon: {
    alignSelf: 'center'
  },
  button: {
    textTransform: 'none',
    display: 'flex'
  }
});

const LocationUpdateInProgress = ({ classes, close, delayed, message }) => {
  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <CircularProgress className={classes.progressIcon} />
        <div className={classes.text}> {message} </div>
        {delayed ? (
          <Button
            variant="contained"
            color="primary"
            size="medium"
            onClick={close}
            classes={{
              root: classes.actionButton
            }}
            id="close">
            Close
          </Button>
        ) : null}
      </div>
    </div>
  );
};

export default withStyles(styles)(LocationUpdateInProgress);
